import React from "react";
import Wordmark from "./Wordmark";

// TASTE EDITIONS — the discovered-depth layer. Same near-black stage, bone
// typography and restrained signal red/blue as the rest of the product; no
// new visual system, no streaming-service catalogue chrome. A card carries
// only what's useful: the name, the round count, and (once played) a
// restrained "Played" mark — never XP/badges/progress.

export default function EditionsView({ editions, loading, onBack, onSelect }) {
  return (
    <div data-testid="editions-view" className="relative min-h-[100dvh] w-full max-w-[560px] mx-auto overflow-x-hidden bg-canvas">
      <div className="relative z-10 px-5 pt-[calc(env(safe-area-inset-top)+20px)] pb-16">
        <div className="flex items-center justify-between">
          <Wordmark variant="horizontal" className="h-3.5" />
          <button
            type="button"
            data-testid="editions-back"
            onClick={onBack}
            className="font-body text-[11px] tracking-[0.18em] uppercase text-white/50 hover:text-white/85"
          >
            ← Back
          </button>
        </div>
        <div className="mt-3 h-px w-full" style={{ background: "linear-gradient(90deg, var(--tt-left), var(--tt-right))", opacity: 0.7 }} />

        <h1 className="mt-7 font-display font-black uppercase tracking-[-0.01em] text-bone text-3xl">
          Taste Editions
        </h1>
        <p className="mt-1.5 font-body text-[13px] text-silver">
          Go deeper. Sharpen your taste.
        </p>

        {loading && (
          <div className="mt-16 text-center font-body text-[12px] tracking-[0.18em] uppercase text-white/40" data-testid="editions-loading">
            Loading editions…
          </div>
        )}

        {!loading && (
          <div className="mt-7 grid grid-cols-2 gap-3" data-testid="editions-grid">
            {editions.map((e) => (
              <button
                key={e.id}
                type="button"
                data-testid={`edition-card-${e.id}`}
                onClick={() => onSelect(e)}
                className="group relative overflow-hidden rounded-2xl bg-[#0b0c11] border border-white/10 px-4 py-5 text-left transition-transform duration-200 active:scale-[0.98] hover:-translate-y-[2px] focus:outline-none"
              >
                <span
                  aria-hidden
                  className="pointer-events-none absolute -inset-6 rounded-[28px] opacity-0 blur-2xl transition-opacity duration-300 group-hover:opacity-30"
                  style={{ background: "linear-gradient(120deg, var(--tt-left), var(--tt-right))" }}
                />
                <div className="relative z-10">
                  {e.played && (
                    <span className="inline-block mb-2 font-mono text-[9px] font-bold tracking-[0.18em] uppercase text-white/45">
                      Played
                    </span>
                  )}
                  <h2 className="font-display font-black uppercase tracking-[-0.01em] text-bone text-base leading-tight">
                    {e.title}
                  </h2>
                  <p className="mt-2 font-mono text-[10px] tracking-[0.18em] uppercase text-subtle">
                    {e.totalRounds} choices
                  </p>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
